<template>
  <div id="app" :class="isHome&&isHui?'apphui':''">
    <!-- nav -->
    <index-top v-if="shouComp"></index-top>
    <router-view></router-view>
    <!-- footer -->
    <index-footer v-if="shouComp"></index-footer>
  </div>
</template>

<script>
import indexTop from "../top";
import indexFooter from "../footer";
import router from "../.././router";
import { LOGOUT, LOGIN } from "../.././vuex/mutation_types";
export default {
  name: "App",
  data() {
    return {
      // active_page: '', // 当前页面路径
      // isLogin: false, // 登录状态,
      shouComp: true,
      isHome: false,
      isHui: null
    };
  },
  mounted() {},
  components: {
    indexTop,
    indexFooter
  },
  created() {
    this.getHui();
    if (this.$route.name == "home") {
      this.isHome = true;
    } else {
      this.isHome = false;
    }
    if (
      this.$route.name == "videoPhone" ||
      this.$route.name == "videoPlayPhone" ||
      this.$route.name == "videoKanPhone"
    ) {
      this.shouComp = false;
      this.addMeta("viewport", "width=device-width");
    } else {
      this.shouComp = true;
      this.addMeta("viewport", "");
    }
  },
  watch: {
    $route(to, from) {
      // console.log("a", to, from);
      // if (from.name == "home") {
      //   let position = window.scrollY; //记录离开页面的位置
      //   // console.log("position", position);
      //   if (position == null) position = 0;
      //   localStorage.setItem("changeRecruitScrollY", position);
      // }
      // if (to.name == "home") {
      //   let recruitScrollY = localStorage.getItem("changeRecruitScrollY");
      //   console.log("recruitScrollY", recruitScrollY);
      //   window.scroll(0, recruitScrollY);
      //   localStorage.removeItem("changeRecruitScrollY");
      // }
      if (this.$route.name == "home") {
        this.isHome = true;
      } else {
        this.isHome = false;
      }
      if (
        this.$route.name == "videoPhone" ||
        this.$route.name == "videoPlayPhone" ||
        this.$route.name == "videoKanPhone"
      ) {
        this.shouComp = false;
        // console.log("a");
        this.addMeta("viewport", "width=device-width");
      } else {
        this.shouComp = true;
        this.addMeta("viewport", "");
      }
    }
  },
  methods: {
    getHui() {
      var that = this;
      that.isHui = localStorage.getItem("ishui") == 1 ? true : false;
      that.$api.index.config({}).then(function(res) {
        if (res.code == 200) {
          console.log("是否置灰",res.result);
          that.isHui = res.result.is_sethui==1?true:false;
          localStorage.setItem("ishui", res.result.is_sethui);
          localStorage.setItem("tongji_url", res.result.tongji_url);
          // if (that.isHui) {
          //   localStorage.setItem("ishui", 1);
          // } else {
          //   localStorage.setItem("ishui", 0);
          // }
        }
      });
    },
    addMeta(name, content) {
      // console.log("1");
      const meta = document.createElement("meta");
      meta.content = content;
      meta.name = name;
      document.getElementsByTagName("head")[0].appendChild(meta);
    }
  },
  mounted() {}
};
</script>
